import { IComment } from 'redhotpie-shared-lib/interfaces/IComment';
import Photo from './photo';
import { IGroupUser, IMainPhoto, IUserCommon } from 'redhotpie-shared-lib/interfaces/IUser';

class Profile {
  userId: number | null;
  userName: string;
  ageTitle: string;
  location: string;
  mainPhoto: IMainPhoto;
  isOnline: boolean;
  isDiamond: boolean;
  isVerified?: boolean;
  online?: boolean;
  displayName?: string;
  isAdmin: boolean;
  isViewable: boolean;
  memberType: string | null;
  age1: number | null;
  age2: number | null;
  memberTypeTitle: { [key: string]: string };
  matchingInterests: number | null;
  memberLevel: number | null;
  countryId: number | null;

  constructor() {
    this.ageTitle = '';
    this.isAdmin = false;
    this.isDiamond = false;
    this.isOnline = false;
    this.isViewable = false;
    this.location = '';
    this.mainPhoto = {
      /* initialize with default values */
    };
    this.userName = '';
    this.userId = 0;
    this.memberType = '';
    this.age1 = 0;
    this.age2 = 0;
    this.memberTypeTitle = {};
    this.matchingInterests = null;
    this.memberLevel = null;
    this.countryId = null;
  }

  static mappingObject(_obj: any): IGroupUser {
    const obj = new Profile();
    obj.ageTitle = _obj.AgeTitle || '';
    obj.isAdmin = _obj.IsAdmin || false;
    obj.isDiamond = _obj.IsDiamond || false;
    obj.isOnline = _obj.IsOnline || false;
    obj.isViewable = _obj.IsViewable || false;
    obj.location = _obj.Location || '';
    obj.mainPhoto = _obj.MainPhoto
      ? Photo.mappingObject(_obj.MainPhoto)
      : {
          /* initialize with default values */
        };
    obj.userName = _obj.UserName || '';
    obj.userId = _obj.MemberID || 0;
    obj.memberType = _obj.MemberType || '';
    obj.memberTypeTitle = {};
    obj.matchingInterests = null;
    obj.memberLevel = null;
    obj.countryId = null;

    return obj;
  }
}

export class Comment {
  commentId: number;
  commentParentId: number;
  subject: string;
  message: string;
  dateCreated: Date | undefined;
  profile: IGroupUser | null;
  replyCount: number;
  messageContentType: string;
  commentCount: number;
  isLiked: boolean;
  likeCount: number;
  imageContent: IMainPhoto | null;

  constructor() {
    this.commentId = 0;
    this.commentParentId = 0;
    this.subject = '';
    this.message = '';
    this.dateCreated = undefined;
    this.profile = null;
    this.replyCount = 0;
    this.messageContentType = '';
    this.commentCount = 0;
    this.isLiked = false;
    this.likeCount = 0;
    this.imageContent = null;
  }

  static mappingObject(_obj: any): IComment {
    const obj = new Comment();
    obj.isLiked = _obj.IsLiked || false;
    obj.likeCount = _obj.LikeCount || 0;
    obj.commentCount = _obj.CommentCount || 0;
    obj.commentId = _obj.CommentID || 0;
    obj.commentParentId = _obj.CommentParentID || 0;
    obj.dateCreated = _obj.DateCreated || undefined;
    obj.message = _obj.Message || '';
    obj.messageContentType = _obj.MessageContentType || '';
    obj.replyCount = _obj.ReplyCount || 0;
    obj.subject = _obj.Subject || '';
    obj.profile = _obj.Profile ? Profile.mappingObject(_obj.Profile) : null;
    obj.imageContent = _obj.ImageContent ? Photo.mappingObject(_obj.ImageContent) : null;

    return obj;
  }
}

interface IVote {
  voteId: number;
  userId: number;
  dateCreated: Date | undefined;
  score: number;
}

class Vote {
  voteId: number;
  userId: number;
  dateCreated: Date | undefined;
  score: number;

  constructor() {
    this.voteId = 0;
    this.userId = 0;
    this.dateCreated = undefined;
    this.score = 0;
  }

  static mappingObject(_obj: any): IVote {
    const obj = new Vote();
    obj.voteId = _obj.VoteID || 0;
    obj.userId = _obj.UserID || 0;
    obj.dateCreated = _obj.DateCreated || undefined;
    obj.score = _obj.Score || 0;
    return obj;
  }
}

export interface IVoteComment {
  vote: IVote | null;
  comment: IComment | null;
}

class VoteComment {
  vote: IVote | null;
  comment: IComment | null;

  constructor() {
    this.vote = null;
    this.comment = null;
  }

  static mappingObject(_obj: any) {
    const obj = new VoteComment();
    obj.comment = _obj.Comment ? Comment.mappingObject(_obj.Comment) : null;
    obj.vote = _obj.Vote ? Vote.mappingObject(_obj.Vote) : null;

    return obj;
  }
}

export interface IClubVoteComments {
  totalItem: number;
  comments: IComment[];
}

export default class ClubVoteComments {
  totalItem: number;
  comments: IComment[];

  constructor() {
    this.totalItem = 0;
    this.comments = [];
  }

  static mappingObject(_obj: any): IClubVoteComments {
    const obj = new ClubVoteComments();
    obj.totalItem = _obj.TotalItems || 0;
    obj.comments = _obj.Comments
      ? _obj.Comments.map((c: any) => {
          return VoteComment.mappingObject(c);
        })
      : [];

    return obj;
  }
}
